

export default {
  userShares: [],
};
